export default "__VITE_ASSET__f9307a38__"